<div class="d-flex justify-content-center">
  <div class="container my-5 simple-form">
    <div class="my-2">
      <tt-ui-custom-single-form
        [formId$]="formId$"
        [user]="user"
        [model$]="model$"
        (submitAction)="submit($event)"
      >
      </tt-ui-custom-single-form>
    </div>
  </div>
</div>

